
<div class="inputWrap {{theme}}">
  <em *ngIf="selected" class="material-icons" (click)="clear()">cancel</em>
  <em *ngIf="isLoading" class="material-icons loading">rotate_left</em>
  <input id="input-{{controlKey}}"
    class="au-{{controlKey}}"
    [ngClass]="{'inputError': control?.invalid && control?.touched}"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [formControl]="searchControl"
    (blur)="onBlur()"
  />
  <div *ngIf="!hideIcon && !selected && !isLoading" class="icon"><em class="material-symbols-rounded">search</em></div>
  <mat-autocomplete #auto="matAutocomplete" class="meilisearchAutocomplete {{type}}" [displayWith]="displayFn" (optionSelected)="selectOption($event.option.value)">
    <mat-option *ngFor="let item of searchResults" [hidden]="!searchControl.value?.length" [value]="item"> {{ item?.name || item?.full_name }}</mat-option>
    <mat-option *ngFor="let item of staticOptions" class="staticOption" [hidden]="!showStatic || !searchControl.value?.length" [value]="item"> {{ item?.name || item?.full_name }}</mat-option>
  </mat-autocomplete>
</div>